export default "__VITE_ASSET__DPpf6mV___"